import React, { useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { CadeteExternoModal } from './CadeteExternoModal';
import { formatarData } from '../utils/helpers';

export const PrintDateModal = ({ show, onClose, availableDates, handlePrint, cadetesExternos, handleAddExternalCadete }) => {
    const [selectedDate, setSelectedDate] = useState('');
    const [showExternalModal, setShowExternalModal] = useState(false);
    const [error, setError] = useState('');

    const handlePrintClick = () => {
        if (!selectedDate) {
            setError("Selecione um dia para gerar a escala.");
            return;
        }
        setError('');
        handlePrint(selectedDate);
        onClose();
    };

    return (
        <>
            <Modal show={show} onClose={onClose} title="Gerar Escala de Serviço (Seleção de Dia)" size="md">
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Selecione o Dia da Escala</label>
                        <select
                            value={selectedDate}
                            onChange={(e) => {setSelectedDate(e.target.value); setError('');}}
                            required
                            className="w-full border p-2 rounded"
                        >
                            <option value="">-- Selecione o dia --</option>
                            {availableDates.map(dateStr => (
                                <option key={dateStr} value={dateStr}>
                                    {formatarData(new Date(dateStr + 'T12:00:00Z'))}
                                </option>
                            ))}
                        </select>
                    </div>

                    <p className="text-sm font-semibold mt-4">
                        Cadetes Externos/Emergenciais Inseridos ({cadetesExternos.length}):
                    </p>
                    {cadetesExternos.length > 0 && (
                        <ul className="list-disc pl-5 text-sm text-gray-600 max-h-20 overflow-y-auto border p-2 rounded">
                            {cadetesExternos.map((c, index) => (
                                <li key={index}>**{c.Nome}** ({c.Pelotao}) - {c.Local}/{c.Turno}</li>
                            ))}
                        </ul>
                    )}
                    
                    <Button onClick={() => setShowExternalModal(true)} variant="outline" className="w-full text-xs">
                        + Inserir Cadete de Outro Pelotão (Emergência)
                    </Button>
                    
                    {error && <p className="text-red-600 mt-2">{error}</p>}
                </div>
                <div className="flex justify-end gap-3 pt-4 border-t mt-4">
                    <Button onClick={onClose} variant="secondary">Cancelar</Button>
                    <Button onClick={handlePrintClick} variant="primary" disabled={!selectedDate}>
                        Gerar PDF do Dia Selecionado
                    </Button>
                </div>
            </Modal>
            
            <CadeteExternoModal
                show={showExternalModal}
                onClose={() => setShowExternalModal(false)}
                handleAddExternalCadete={handleAddExternalCadete}
            />
        </>
    );
};

